module.exports = __webpack_public_path__ + "img/Dilophosaurus_Splash.77824e5b.jpg";